"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_Provenance_Entity = exports.Provenance_EntityRoleKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_Provenance_Agent_1 = require("./RTTI_Provenance_Agent");
var Provenance_EntityRoleKind;
(function (Provenance_EntityRoleKind) {
    Provenance_EntityRoleKind["_derivation"] = "derivation";
    Provenance_EntityRoleKind["_revision"] = "revision";
    Provenance_EntityRoleKind["_quotation"] = "quotation";
    Provenance_EntityRoleKind["_source"] = "source";
    Provenance_EntityRoleKind["_removal"] = "removal";
})(Provenance_EntityRoleKind = exports.Provenance_EntityRoleKind || (exports.Provenance_EntityRoleKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_Provenance_Entity = t.recursion('IProvenance_Entity', function () {
    return t.intersection([
        t.type({
            what: RTTI_Reference_1.RTTI_Reference
        }),
        t.partial({
            id: t.string,
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            role: (0, EnumType_1.createEnumType)(Provenance_EntityRoleKind, 'Provenance_EntityRoleKind'),
            _role: RTTI_Element_1.RTTI_Element,
            agent: t.array(RTTI_Provenance_Agent_1.RTTI_Provenance_Agent)
        })
    ]);
});
//# sourceMappingURL=RTTI_Provenance_Entity.js.map